import React from 'react';
import { usePullDatasourceTSMutation } from 'Services/api/reportsApi';
import { WindRose2 } from 'lib/DemoWidgets/WindRose/WindRose2';
import { useWidgetData } from 'Utils/Widgets/WidgetWrapper';
import { getQuery } from 'Features/StationsNew/Datasources/Datasource/Monitors/utils';
import { ChartResponse, WindRoseChartWidgetOptions } from 'Features/StationsNew/Datasources/Datasource/Monitors/types';

export function WindRoseChart({ options }: {options: WindRoseChartWidgetOptions}) {
  const { arrowDataInfo } = options;
  const [load, result] = usePullDatasourceTSMutation();
  const { values } = useWidgetData({ request: arrowDataInfo, params: { hasWebsocket: true, hasTimeout: false } });

  React.useEffect(() => {
    load(getQuery(options));
  }, [load, options]);

  const chartData = Array.from({ length: 360 / 15 }, () => 0);
  const segmentAngle = 360 / chartData.length;

  const data: ChartResponse[] = result.data?.[0].response ?? [];
  const arrowAngle: string = (values as ChartResponse[])?.[0]?.v;

  let sum = 0;

  data.forEach((item) => {
    if (item) {
      let index = Math.round((+item.v) / segmentAngle);

      if (index < 0) {
        index += chartData.length;
      }

      if (index >= chartData.length) {
        index -= chartData.length;
      }

      sum += 1;
      chartData[index] += 1;
    }
  });

  const percentData = chartData.map((item) => Math.round((item / sum) * 100));
  const arrowColor = 'rgb(100, 100, 100)';

  return (
    <div>
      <WindRose2
        title={['Роза ветров за 24 часа;', 'Текущее направление ветра']}
        datasets={[{
          label: 'Ветер',
          data: percentData,
        }]}
        arrowAngle={+arrowAngle}
        arrowColor={arrowColor}
        formatter={percentFormatter}
        showLegend={false}
        showTicks={false}
        showZero={false}
        zeroValue={0}
      />
    </div>
  );
}

function percentFormatter(value: number | string) {
  return `${value}%`;
}
